import {
    HttpGetTransferWarehouse,
    HttpGetDestination,
    HttpGetTransferWarehouseAdmin
} from "@/service/transferplan";
export default {
    data() {
        return {
            isAdmin: false,
            mixinWarehouseList: [],
            mixinDestinationList: []
        }
    },
    created() {
        this.getMixinDestList();
        this.getMixinWarehouse(false);
    },
    methods: {
        getMixinDestList() {
            HttpGetDestination().then(res => {
                let destinationList = res.data.map(item => {
                    return {
                        label: item.code,
                        value: item.code
                    }
                });
                destinationList.unshift({
                    value: 'other',
                    label: "Other"
                });
                this.$set(this, 'mixinDestinationList', destinationList);
            }, err => {
                this.$VMessage.error(err.message);
            });

        },
        getMixinWarehouse(isAdmin) {
            if (isAdmin) {
                HttpGetTransferWarehouseAdmin().then(res => {
                    let warehouseList = res.data.map(item => ({
                        label: item.title ? `${item.code}(${item.title})` : item.code,
                        value: item.id,
                        attach: {
                            ...item
                        }
                    }));
                    this.$set(this, 'mixinWarehouseList', warehouseList);
                }, err => {
                    this.$VMessage.error(err.message);
                });
            }
            else {
                HttpGetTransferWarehouse().then(res => {
                    let warehouseList = res.data.map(item => ({
                        label: item.title ? `${item.code}(${item.title})` : item.code,
                        value: item.id,
                        attach: {
                            ...item
                        }
                    }));
                    this.$set(this, 'mixinWarehouseList', warehouseList);
                }, err => {
                    this.$VMessage.error(err.message);
                });
            }
        }
    },
}